var SocialShare = {

  url: '',
  title: '',
  width: 626,
  height: 436,
  left: 0,
  top: 0,

  init: function () {
    SocialShare.left = (screen.width / 2) - (SocialShare.width / 2);
    SocialShare.top = (screen.height / 2) - (SocialShare.height / 2);
    SocialShare.handlers();
  },

  handlers: function () {
    jQuery(document).on("click", ".socialshare a", function () {
      var container = jQuery(this).closest(".socialshare");
      var url = container.data('href');
      var title = container.data('title');
      var social = jQuery(this).data('social');

      SocialShare.set(url, title);

      if (typeof SocialShare[social] !== 'undefined') {
        SocialShare[social]();
      }

      return false;
    });
  },

  set: function (url, title) {
    SocialShare.url = encodeURIComponent(url);
    SocialShare.title = encodeURIComponent(title);
  },

  facebook: function () {
    window.open('https://www.facebook.com/sharer/sharer.php?u=' + SocialShare.url, 'sharer', 'width=' + SocialShare.width + ',height=' + SocialShare.height + ', top=' + SocialShare.top + ', left=' + SocialShare.left);
  },

  twitter: function () {
    window.open("https://twitter.com/intent/tweet?url=" + SocialShare.url + "&text=" + SocialShare.title, "", 'width=' + SocialShare.width + ',height=' + SocialShare.height + ', top=' + SocialShare.top + ', left=' + SocialShare.left);
  }

};

var Cairolibri = {

  handlers: function () {

  },

  init: function () {

    jQuery(window).scroll(function () {
      var top = jQuery(window).scrollTop();
      if (top > 50) {
        jQuery("body").addClass('stickied-navbar');
      } else {
        jQuery('body').removeClass('stickied-navbar');
      }
    });

    jQuery(document).on("click", ".scrollup", function () {
      var body = jQuery("html, body");
      body.stop().animate({scrollTop: 0}, 300, 'swing', function () {

      });
    });

    jQuery(document).on("click", ".navbar-toggler", function () {
      if (jQuery(this).attr('aria-expanded') === 'true') {
        jQuery('body').addClass('navbar-mobile-menu-expanded');
      } else {
        jQuery('body').removeClass('navbar-mobile-menu-expanded');
      }
    });

    jQuery(document).on("submit", "#cairolibri-contact", function () {
      var form = document.getElementById("cairolibri-contact");
      var formJ = jQuery("#cairolibri-contact");

      if (form.checkValidity()) {
        var formData = formJ.serialize();

        var data = {
          'action': 'contact',
          'data': formData
        };

        jQuery(formJ).find(":input").each(function () {
          var input = jQuery(this);
          input.removeClass('is-invalid');
        });

        jQuery(formJ).find(".form-group-recaptcha .invalid-feedback").hide();
        jQuery(formJ).find(".form-group-attachment .invalid-feedback").hide();
        jQuery(formJ).find(".form-group-attachment").removeClass('is-attachment-invalid');

        jQuery(".contact-loading-container").show();

        var fd = new FormData();
        jQuery.each(formJ.serializeArray(), function (j, field) {
          fd.append(field.name, field.value);
        });

        var fileInputElement = document.getElementById("field-attachment");
        fd.append("attachment", fileInputElement.files[0]);

        jQuery.ajax({
          type: 'POST',
          url: ajax_params.ajax_url,
          data: fd,
          contentType: false,
          processData: false,
          success: function (response) {
            jQuery(".contact-loading-container").hide();
            grecaptcha.reset();
            if (typeof response.error !== 'undefined') {
              var firstErrorKey = null;
              var firstErrorTopPosition = 0;
              jQuery.each(response.error, function (key, value) {
                var field = formJ.find("#field-" + key);
                if (firstErrorKey === null) {
                  firstErrorKey = key;
                  firstErrorTopPosition = jQuery(field).offset().top - 80;
                }
                field.addClass('is-invalid');
                if (key === 'g-recaptcha-response') {
                  jQuery(".form-group-recaptcha .invalid-feedback").show();
                }
                if (key === 'attachment') {
                  jQuery(".form-group-attachment").addClass('is-attachment-invalid');
                  jQuery(".form-group-attachment .invalid-attachment-feedback").show();
                }
              });

              var body = jQuery("html, body");
              body.stop().animate({scrollTop: firstErrorTopPosition}, 500, 'swing', function () {

              });
            } else {
              swal({
                title: "Inviato con successo!",
                text: "Il tuo messaggio è stato inviato con successo.\nRiceverai una risposta il prima possibile.",
                type: "success",
                confirmButtonText: "Chiudi"
              });
            }
            ;
          }
        });
      }

      formJ.addClass('was-validated');

      return false;
    });

  }

};

var SLswiper = {
    sliders: [],
    options: {
      slidesPerView: 4,
      spaceBetween: 0,
      loop: true,
      loopFillGroupWithBlank: true,
      centeredSlides: false,
      speed: 2000,
      autoplay: {
        delay: 1000,
        disableOnInteraction: false,
      },
      grabCursor: true,
      navigation: {
        nextEl: '.swiper-control-next',
        prevEl: '.swiper-control-prev',
      },
      breakpoints: {
        1200: {
          slidesPerView: 4,
          spaceBetween: 30,
        },
        991: {
          slidesPerView: 3,
          spaceBetween: 15,
        },
        767: {
          slidesPerView: 2,
          spaceBetween: 20,
        },
        490: {
          slidesPerView: 1,
          spaceBetween: 10,
        }
      },
      on: {
        resize: function () {
            this.autoplay.stop();
            this.autoplay.start();
        },
      },
    },
    init: function () {
        var t = this;
        jQuery('.swiper-container').each(function(index, element){
            jQuery(this).addClass('s'+index);
            var slider = new Swiper('.swiper-container.s'+index, t.options);
            slider.el.addEventListener("mouseenter", function( event ) {
                slider.autoplay.stop();
            }, false);
            slider.el.addEventListener("mouseleave", function( event ) {
                if(slider.animating) {
                    slider.on('transitionEnd', function () {
                        slider.autoplay.start();
                        slider.off('transitionEnd')
                    });
                } else {
                    slider.autoplay.start();
                }
            }, false);
            slider.el.addEventListener("touchend", function( event ) {
                if(slider.animating) {
                    slider.on('transitionEnd', function () {
                        slider.autoplay.start();
                        slider.off('transitionEnd')
                    });
                } else {
                    slider.autoplay.start();
                }
            }, false);
            t.sliders.push(slider);
        });
    },
}
jQuery(document).ready(function ($) {
    SLswiper.init();
    Cairolibri.init();
    SocialShare.init();

});